import angular from "angular";
import CustomerSources from "./CustomerSources.vue";
import CustomerSourcesController from "./customer-sources.controller";
import template from "./customer-sources.html";
import Vue from "vue";
import "ngVue";

function config($stateProvider, $urlRouterProvider, USER_ROLES) {
  $stateProvider.state("drivecoach.admin.crm.customersources", {
    url: "/customer-sources",
    template: template,
    controller: CustomerSourcesController,
    controllerAs: "vm",
    data: {
      authorizedRoles: [
        USER_ROLES.admin,
        USER_ROLES.administrator,
        USER_ROLES.owner,
      ],
    },
  });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];

export default angular
  .module("admin.crm.customersources", [])
  .config(config)
  .directive("dcCustomerSources", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(
        Vue.component("DcCustomerSources", CustomerSources),
      );
    },
  ]);

